import moment from 'moment';
import { v4 as uuid } from 'uuid';
import hmacSHA512 from 'crypto-js/hmac-sha512';

/**
 * Returns the credentials required for HMAC authentication
 *
 * @param {string} method
 * @param {string} url
 */
export const getHmacCredentials = (method, url) => {
    // lambda api routes
    const requestURI = `/v1${url?.replace(process.env.API_BASE_URL, '')}`;

    const requestTimeStamp = moment().format();
    const nonce = uuid();
    const signatureRawData = method + requestTimeStamp + requestURI;

    const byteArray = new Uint8Array(JSON.parse(process.env.HMAC_AUTH_SECRET));
    const secret = new TextDecoder().decode(byteArray);

    const signature = hmacSHA512(signatureRawData, secret + nonce);
    const authToken = `fb-api ${nonce}:${signature}`;

    return {
        token: authToken,
        date: requestTimeStamp,
    };
};
